export const ages = [
  'under 18',
  '18-24',
  '25-39',
  '40-59',
  '60-75',
  'over 75',
];

export const jobs = [
  'In College',
  'In Graduate School',
  'Working Full Time',
  'Working Part Time',
  'Looking to Enter/Return to College',
  'Seeking Employment/Job Change',
  'Other',
];
